import * as React from "react";

export const PrevArrow = ({ onClick }) => (
  <div>
    <div className="prev-arrow" onClick={onClick} />
  </div>
);
